import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';

import t from '../../lib/I18n';
import config from '../../config';

const StepDetail = ({ steps, currentStep, hideSteps, stepTitleTagName, dictionaryPrefix }) => {

    const currentStepName = _.findKey(steps, step => step === currentStep);
    const isSmartcardStep = currentStepName === 'SMARTCARD';

    const filteredSteps = Object.entries(steps)
        .filter(([stepName]) => !hideSteps.includes(stepName));

    const getStepNumber = () => {
        const index = filteredSteps.findIndex(step => step[1] === currentStep);
        return index + 1;
    };

    return (
        <div className="step-detail">
            <span className="step-detail__count">
                {t('account.register.steps.count', {
                    stepNumber: getStepNumber(),
                    totalSteps: filteredSteps.length,
                })}
            </span>

            <FormattedHTMLMessage
                message={`${dictionaryPrefix}${currentStepName.toLowerCase()}${
                    isSmartcardStep ? '.title-mobile' : '.title'
                }`}
                tagName={stepTitleTagName}
                className={classnames('step-detail__heading', {
                    'step-detail__heading--smartcard': isSmartcardStep,
                })}
            />
            {isSmartcardStep && (
                <React.Fragment>
                    <p>{t('account.register.smartcard.body')}</p>
                    <a href={config.get('smartcardReadMoreUrl')} target="_blank">
                        <img
                            src={config.get('smartcardLogo')}
                            alt={t('account.register.smartcard.logo.alt')}
                            className="step-detail__smartcard-logo"
                        />
                    </a>
                </React.Fragment>
            )}
        </div>
    );
};

StepDetail.propTypes = {
    steps: PropTypes.object,
    currentStep: PropTypes.number,
    hideSteps: PropTypes.func,
    stepTitleTagName: PropTypes.string,
    dictionaryPrefix: PropTypes.string,
};

StepDetail.defaultProps = {
    steps: {},
    currentStep: 0,
    hideSteps: [],
    stepTitleTagName: 'h4',
    dictionaryPrefix: '',
};

export default StepDetail;
